import { Divider, Tab, Tabs } from '@mui/material';
import { Link, Outlet, useLocation } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/organisms/page/page';

export const OrganizationDetailsContainer = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const tabs = [
    {
      href: '/tenant/organization-details',
      label: t('organizationDetails:tabs.organizationDetails'),
    },
    {
      href: '/tenant/organization-details/admins',
      label: t('organizationDetails:tabs.admins'),
    },
  ];

  return (
    <Page>
      <Tabs
        allowScrollButtonsMobile
        sx={{ mt: 4 }}
        value={tabs.findIndex(tab => tab.href.includes(location.pathname))}
        variant="scrollable">
        {tabs.map(option => (
          <Tab
            component={Link}
            key={option.href}
            label={option.label}
            to={option.href}
          />
        ))}
      </Tabs>
      <Divider />
      <Outlet />
    </Page>
  );
};
